import { BaseInputV2 } from "src/components/BaseInputV2/BaseInputV2.tsx";

import { BaseInputV2Adornment } from "src/components/BaseInputV2/BaseInputV2Adornment.tsx";

import { SearchIcon } from "src/lib/ui-icon-v2";
import * as styles from "./SearchBar.styles.ts";
import { observer } from "mobx-react-lite";
import { useExonnHubStore } from "src/admin/modules/b2b-gate-order/components/ExonnHub/useExonnHubStore.ts";
import { type ChangeEvent, type KeyboardEvent } from "react";

export const SearchBar = observer(() => {
  const store = useExonnHubStore();
  const value = store.search;
  const draftValue = store.draftSearch;

  const handleClear = () => {
    store.clearSearch();
    store.setDraftSearch("");
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      if (draftValue !== value) {
        store.setSearch(draftValue);
      }
      e.currentTarget.blur();
    }
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value;
    store.setDraftSearch(value);
  };

  return (
    <BaseInputV2
      value={draftValue}
      css={styles.root}
      onKeyDown={handleKeyDown}
      onChange={handleChange}
      startAdornment={
        <BaseInputV2Adornment>
          <SearchIcon />
        </BaseInputV2Adornment>
      }
      endAdornment={
        value && (
          <BaseInputV2Adornment isAction={true} onClick={handleClear}>
            <i className="icon-15-clear_x" />
          </BaseInputV2Adornment>
        )
      }
    />
  );
});
